"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.XIcon20Solid = forwardRef_1.forwardRef('XIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M3.44 3.44a1.5 1.5 0 0 1 2.12 0L10 7.878l4.44-4.44a1.5 1.5 0 0 1 2.12 2.122L12.122 10l4.44 4.44a1.5 1.5 0 0 1-2.122 2.12L10 12.122l-4.44 4.44a1.5 1.5 0 0 1-2.12-2.122L7.878 10l-4.44-4.44a1.5 1.5 0 0 1 0-2.12Z" })));
});
